import { createFileRoute } from "@tanstack/react-router";
import { ReplayPage } from "@/features/game-resources";
import { loadReplay } from "@/features/game-resources/records";
import {
  resourceHead,
  resourceSearchSchema,
} from "@/features/game-resources/navigation";

export const Route = createFileRoute(
  "/_site/$coworld_/episodes/$episodeId_/replay",
)({
  validateSearch: (search) => resourceSearchSchema.parse(search),
  loaderDeps: ({ search }) => ({ search }),
  loader: ({ params, deps, abortController }) =>
    loadReplay({
      data: {
        resourceId: params.episodeId,
        game: { slug: params.coworld, catalog_status: "listed" },
        target: "episode",
        search: deps.search,
      },
      signal: abortController.signal,
    }),
  head: () => resourceHead("Replay"),
  component: Page,
});

function Page() {
  return <ReplayPage data={Route.useLoaderData()} />;
}
